module.exports = __webpack_public_path__ + "static/media/dissectProcess2.4a96bf4a.jpeg";